import React from 'react';
import moment from 'moment';

import TextTag from 'common-components/tags/TextTag';
import { Text } from 'common-components/typography';
import { BookingTypeIcon } from 'common-components/tags';
import { BookingType, ShiftSlotStatus } from 'utilities/enum-utils';
import { Broadcast } from '@good/icons';

import { ROSTER_WEEKLY_CONFIG } from '../roster-weekly-config';
import { IRosterShift } from '../../types';
import { Badge, Paper, UnstyledButton } from '@good/ui/core';
import { useBookings } from 'views/bookings-v2/books-view-context/bookings-view-context';
import { ROSTER_TAB } from '../../components/roster-common-enums';

const { ITEM_CARD_HEIGHT } = ROSTER_WEEKLY_CONFIG;

interface OpenSlotCardProps {
  shift: IRosterShift;
}

export function OpenSlotCard({ shift }: OpenSlotCardProps) {
  const { shiftStartDateTime, shiftEndDateTime, serviceName, duplicateCount } = shift;
  const mStartDate = moment(shiftStartDateTime);
  const mEndDate = moment(shiftEndDateTime);
  const startDateDisplay = mStartDate.format('h:mm a');
  const endDateDisplay = mEndDate.format('h:mm a');
  const onSelectRosterItem = useBookings((selector) => selector.onSelectRosterItem);
  const selectedRosterItem = useBookings((selector) => selector.selectedRosterItem);
  const isSelected = selectedRosterItem?.bookingId === shift.bookingId;

  return (
    <>
      <UnstyledButton
        onClick={() => onSelectRosterItem({ item: shift, type: 'openSlot', tab: ROSTER_TAB.WEEKLY })}
        w='100%'
        h='100%'
        display='flex'
        style={{
          boxShadow: isSelected ? '0 0 0 2px var(--mantine-color-orange-6)' : '',
          borderRadius: 'calc(var(--mantine-radius-md) - 2px)',
        }}
      >
        <Paper
          withBorder
          w='100%'
          shadow={isSelected ? 'xl' : 'xs'}
          p={8}
          mih={ITEM_CARD_HEIGHT}
          bg='yellow.0'
          className='anim-fade-in border-dashed'
          style={{ overflow: 'hidden', borderColor: 'var(--mantine-color-yellow-5)' }}
        >
          <div className='flex-row'>
            <div className='inline-block'>
              {duplicateCount !== undefined && duplicateCount > 1 && (
                <TextTag content={`${duplicateCount}x`} color={'orange-light'} size='small' className='mr-x-small' />
              )}
            </div>

            <div className='inline-block flex-row align-center'>
              {shift.shiftSlotStatus === ShiftSlotStatus.PUBLISHING ||
              shift.shiftSlotStatus === ShiftSlotStatus.PUBLISHED ? (
                <div className='flex-row align-center'>
                  <Broadcast className='mr-x-small' />
                  <span className='mr-x-small' style={{ fontSize: '10px', lineHeight: '1' }}>
                    {' '}
                  </span>
                  <TextTag content='Published' size='small' theme='light' color='rose' backgroundColor='white' />
                </div>
              ) : (
                <Badge size='md' variant='outline' color='orange' bg='white'>
                  Open slot
                </Badge>
              )}
            </div>
          </div>

          <div className='whitespace-nowrap overflow-hidden text-overflow-ellipsis' style={{ width: '100%' }}>
            <Text size='regular' lineHeight={120}>
              <b>{startDateDisplay}</b> - {endDateDisplay}
            </Text>
            <br />
            <div className={'flex-row align-center'}>
              <div style={{ minWidth: '16px' }}>
                <BookingTypeIcon
                  type={
                    shift.bookingType === BookingType.ACTIVITY_RECORD ? BookingType.ACTIVITY_RECORD : shift.serviceType
                  }
                  className={'mr-x-small'}
                />
              </div>
              <Text size='regular' lineHeight={120}>
                {serviceName}
              </Text>
            </div>
          </div>
        </Paper>
      </UnstyledButton>
    </>
  );
}
